import type { DealType } from './azureReferralSchema'
import { AZURE_DEAL_TYPE, SHARED_AZURE_DEAL_TYPES } from './azureReferralSchema'

export type { DealType }

export const isServicesCosellDealType = (
  dealType?: DealType | string
): boolean => dealType === AZURE_DEAL_TYPE.SERVICES_CO_SELL

export const isSolutionRequiredForDealType = (
  dealType?: DealType | string
): boolean => Boolean(dealType) && !isServicesCosellDealType(dealType)

export const shouldShowPartnerRole = ({
  dealType,
  partnerRole,
}: {
  dealType?: DealType | string
  partnerRole?: string
}): boolean =>
  isServicesCosellDealType(dealType) || Boolean(partnerRole?.trim())

export const isIpCosellDealType = (dealType?: DealType | string): boolean =>
  dealType === AZURE_DEAL_TYPE.IP_CO_SELL

export const isPrivateDealType = (dealType?: DealType | string): boolean =>
  dealType === AZURE_DEAL_TYPE.PRIVATE

export const isPartnerLedDealType = (dealType?: DealType | string): boolean =>
  dealType === AZURE_DEAL_TYPE.PARTNER_LED

export const isSharedCosellDealType = (dealType?: DealType | string): boolean =>
  (SHARED_AZURE_DEAL_TYPES as readonly string[]).includes(dealType ?? '')

export const isNonSharedDealType = (dealType?: DealType | string): boolean =>
  isPrivateDealType(dealType) || isPartnerLedDealType(dealType)

export const isCosellDealTypeRevertBlocked = ({
  createdDealType,
  nextDealType,
  referralLifecycle,
}: {
  createdDealType?: DealType | string
  nextDealType?: DealType | string
  referralLifecycle: 'new' | 'created'
}): boolean =>
  referralLifecycle === 'created' &&
  isSharedCosellDealType(createdDealType) &&
  isNonSharedDealType(nextDealType)
